import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { NewAmlCheckModal } from "./NewAmlCheckModal";

export const NewAmlCheckButton = observer(() => {
  const { actionModals, checkLimit, user, amlCheckList } = useStores();

  const { isCustomer, isProvider } = user.roles;

  const newAmlCheckHandler = () => {
    actionModals.open(() => <NewAmlCheckModal />, {
      width: "600px",
      noValidation: true,
      isOverlayClose: false,
      title: "Проверить кошелек",
      onApply: () => {
        return Promise.resolve();
      },
      onClose: () => {
        amlCheckList.fetch();
        if (isCustomer || isProvider) {
          checkLimit.refetchLimit();
        }
      },
    });
  };

  return (
    <CustomButton onClick={newAmlCheckHandler} disabled={checkLimit.dailyLimit === 0}>
      Новая проверка
    </CustomButton>
  );
});
